import { currency as currencyCatalog } from '@machete/common-catalogs';

function toCurrency(number = 0, currency = 'MXN', decimals) {
  let wrongValue = number;

  const formatterOptions = {
    style: 'currency',
    currency,
    maximumFractionDigits: decimals,
  };

  const formatter = new Intl.NumberFormat('es-MX', formatterOptions);

  wrongValue = parseFloat(wrongValue);

  if (Number.isNaN(wrongValue)) wrongValue = 0.00;

  const value = formatter.format(wrongValue);

  return value;
}

const fixTotals = (value, currency, decimals) => (
  parseFloat(toCurrency(value, currency, decimals).replace(/[a-zA-Z ,$]/g, ''))
);

const toRoundedNumber = (value, currency) => (
  value.toLocaleString('es-MX', { style: 'currency', currency })
);

function decimalsCurrency(currency) {
  const { decimals = 2 } = currencyCatalog.find(({ key }) => key === currency);

  return decimals;
}

function standardRounding(value, currency = 'MXN') {
  const amount = (parseFloat(
    toRoundedNumber(Math.abs(value), currency).replace(/[a-zA-Z ,$]/g, ''),
  )).toFixed(decimalsCurrency(currency));

  return (value < 0) ? -amount : amount;
}

const getDocumentType = (invoice) => {
  let type = 'pre';

  const { voucherType } = invoice;
  const { digitalTaxStamp } = invoice.complement;

  const {
    isSaleNote,
    isSalaryReceipt,
    isAutoInvoice,
  } = invoice.operation;

  if (isSaleNote) {
    return 'saleNote';
  }

  if (isSalaryReceipt) {
    return 'salaryReceipt';
  }

  if (isAutoInvoice) {
    type = 'autoInvoice';
  }

  if (digitalTaxStamp && digitalTaxStamp.uuid) {
    switch (voucherType) {
      case 'I':
        type = 'invoice';
        break;
      case 'E':
        type = 'creditNote';
        break;
      case 'T':
        type = 'tradeTransfer';
        break;
      case 'P':
        type = 'rep';
        break;
      case 'N':
        type = 'payroll';
        break;
      default:
        break;
    }
  }

  return type;
};

const mapCatalog = catalog => catalog.map(i => ({
  value: i.key,
  label: `${i.key} - ${i.value}`,
}));

export default {
  toCurrency,
  fixFloat: (value, decimals = 4) => value.toFixed(decimals),
  fixTotals,
  standardRounding,
  getDocumentType,
  mapCatalog,
};
